import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"

import { event } from "./auth"
event("page_view", "/")

window.__app_env = process.env

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)
